/**
 * Index route: send each role to the story that matches their day job.
 * Ops roles see the operations dashboard; VC / customer / field roles redirect.
 */
import { Navigate } from "react-router-dom";
import { getUser } from "./session";
import { homePathForRole } from "./homePath";
import { OperationsDashboard } from "../dashboard/screens/OperationsDashboard";

export function RoleHomeRedirect() {
  const user = getUser();
  const role = user?.role;
  const target = homePathForRole(role);

  if (target !== "/") {
    return <Navigate to={target} replace />;
  }

  return <OperationsDashboard />;
}
